<template>
  <div class="service-quoted-price">
     <h2>即時報價系統</h2>
     <p>網站內所有客製金牌的黃金計價，均連結國際即時報價系統，該即時報價為每分鐘更新，參考網站請連結<a class="website-tw9999" href="http://tw9999.tw">臺灣銀樓。</a></p>
     <div class="mobile_backNav" v-if="isMobileButtonShow">
       <i class="fa fa-angle-left"></i>
       <router-link to="/gold/service_mobile">返回說明與服務</router-link>
     </div>
  </div>
</template>

<script>
export default {
  name: "serviceGuotedPrice",
  data() {
    return {
      isMobileButtonShow: false
    };
  },
  created() {
    let device = this.$store.getters.getDeviceSize;
    if (device < 585) {
      this.isMobileButtonShow = true;
    }
  }
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.service-quoted-price {
  width: 66.73%;
  text-align: left;
  min-height: calc(100vh - 377px);
  h2 {
    font-size: 35px;
    font-weight: 600;
    letter-spacing: 2px;
    color: $primaryDeepColor;
    margin-top: 0;
  }
  p {
    font-size: 17px;
    color: $secondaryDeepColor1;
    line-height: 30px;
  }
}
.website-tw9999 {
  color: $primaryLightColor;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}
.mobile_backNav {
  margin-top: 24px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    color: $primaryDeepColor;
    margin-right: 10px;
  }
  a {
    color: $primaryDeepColor;
  }
}
</style>
